import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ClientInvoiceLineItem from '../../../../Domain/ClientInvoiceLineItem';
import VZeusLineItemOpenService from '../../../../Services/VZeusLineItemOpenService';
import ClientInvoiceLineItemSearchParams from './ClientInvoiceLineItemSearchParams';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import CreateLineItemWindowDescription from './CreateLineItemWindowDescription';
import ClientLineItemService from '../../../../Services/ClientLineItemService';
import ClientInvoiceService from '../../../../Services/ClientInvoiceService';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ApplyPaymentItem from '../../../../Domain/ApplyPaymentItem';
import ClientPaymentService from '../../../../Services/ClientPaymentService';
import ApplyPaymentPanel from '../../../Finance/ClientPayment/ApplyPaymentPanel';
import ClientInvoiceLineItemModify from '../../../../Domain/ClientInvoiceLineItemModify';

export default class LineItemsSubTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0,
    type: 'all',
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new ClientInvoiceLineItemSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      numberOfElementsInTheTable: 0,
      clientId: 0,
      currencyId: 0,
      statusId: null,
      selectedItem: {},
    };

    this.refresh = this.refresh.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.removePaymentFunction = this.removePaymentFunction.bind(this);
    ClientInvoiceLineItem.editFunction = this.editFunction.bind(this);
    ClientInvoiceLineItem.isDisabled = this.isEditDisabled.bind(this);
  }

  componentDidMount() {
    ClientInvoiceService.GetByInvoiceId(this.props.clientInvoiceId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          this.setState({ clientId: result.ciCcid, currencyId: result.ciRcyid, statusId: result.ciStatusCode });
        }
      })
      .catch((error) => ErrorMessage.SetErrorMessage('LIST54', error));
  }

  isButtonDisabled() {
    return !this.state.statusId || this.state.statusId === 2 || this.state.statusId === 3;
  }

  // The row's Edit action outlives finalization, unlike adding and removing line items: the
  // internal line item type is editable on a finalized (or paid) invoice, and the editor locks
  // every other field in that case. A cancelled invoice is not editable at all.
  isEditDisabled(item) {
    // Assignment rows are not ClientLine rows, so this editor cannot save them.
    if (item && item.LineItemType === 'Assignment') {
      return true;
    }
    return !this.state.statusId || this.state.statusId === 4;
  }

  isInvoiceFinalized() {
    return this.state.statusId === 2 || this.state.statusId === 3;
  }

  editFunction(id, item) {
    const selectedItem = new ClientInvoiceLineItemModify();
    selectedItem.ClCiId = this.props.clientInvoiceId;
    selectedItem.ClLliid = item.LineItemTypeId;
    selectedItem.InternalLineItemTypeLookupValue = item.InternalLineItemTypeId ?? item.LineItemTypeId;
    selectedItem.IsInvoiceFinalized = this.isInvoiceFinalized();
    selectedItem.ClCfId = item.ProjectId;
    selectedItem.ClServiceId = item.ServiceId;
    //selectedItem.ClOpportunityId = item.OpportunityId;
    selectedItem.ClDesc = item.Name;
    selectedItem.ClTotal = item.InitDue;
    selectedItem.CurrencyId = this.state.currencyId;
    selectedItem.CcId = this.state.clientId;
    selectedItem.LineItemId = item.LineItemId;
    selectedItem.TiedToType = item.ProjectId ? 'Project' : 'Service' /*item.ServiceId ? 'Service' : 'Opportunity'*/;

    this.setState({ shownPanel: ShownPanelsEnum.EditItem, selectedItem });
  }

  componentDidUpdate() {
    const searchItem = new ClientInvoiceLineItemSearchParams();
    searchItem.ClientInvoiceId = this.props.clientInvoiceId;
    searchItem.Type = this.props.type;
    if (searchItem.Type !== this.state.searchItem.Type) this.setState({ searchItem });
  }

  refresh(reload) {
    if (reload) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => {
                VZeusLineItemOpenService.ExportToExcel(this.state.searchItem)
                  .then((result) => {
                    if (result && result.error) {
                      ErrorMessage.SetErrorMessage(result.error);
                    } else {
                      ErrorMessage.SetNotification('Exported to Excel.');
                    }
                  })
                  .catch(() => ErrorMessage.SetErrorMessage('LIST126'));
              },
              label: 'Export to Excel',
              tooltip: 'Export to Excel',
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () =>
                ErrorMessage.SetApprove(
                  `Remove ${this.getNumberOfSelectedElements()} Line Item(s) from their invoice?`,
                  this.removeFunction
                ),
              label: 'Remove Line Items',
              tooltip: 'Remove Line Items',
              roleKey: 'clientinvoice_removelineitem',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              iconName: 'fa-solid fa-plus-circle',
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
              label: 'New Line Item',
              tooltip: 'New Line Item',
              roleKey: 'clientinvoice_newlineitem',
              disabled: this.isButtonDisabled(),
              hidden: this.props.type !== 'lineitem',
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => {
                this.setState({
                  shownPanel: ShownPanelsEnum.ApplyPayment,
                  selectedItem: this.getApplyPaymentItem(),
                });
              },
              label: 'Apply Payment(s)',
              tooltip: 'Apply Payment(s)',
              roleKey: 'clientpayment_apply',
              disabled: this.getNumberOfSelectedElements() === 0 || this.state.statusId !== 2,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.removePaymentFunction),
              label: 'Remove Payment(s)',
              tooltip: 'Remove Payment(s)',
              roleKey: 'clientpayment_remove',
              disabled:
                this.getNumberOfSelectedElements() === 0 || (this.state.statusId !== 2 && this.state.statusId !== 3),
              hidden: this.props.type === 'unpaid',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  removePaymentFunction() {
    const selectedItem = new ApplyPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.getNumberOfSelectedElements();
    selectedItem.ClientPaymentId = this.props.clientPaymentId;
    selectedItem.ClientInvoiceId = this.props.clientInvoiceId;
    selectedItem.LineItemIds = this.state.itemList.filter((x) => x.Selected === true).map((f) => f.LineItem);
    selectedItem.LineItemSearchParams = this.state.searchItem;

    ClientPaymentService.RemovePayment(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment removed from Assignment(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AST159', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Remove the payment of all currently selected (${this.state.numberOfElementsInTheTable}) Line Items?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.LineItemId);
    return `Remove the payment of the selected ${idList.length} Line Item(s)?`;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateLineItemWindowDescription}
            errorCode={'LIST134'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.getEditItem()}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateLineItemWindowDescription}
            errorCode={'LIST145'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.ApplyPayment,
          <ApplyPaymentPanel
            baseItem={this.state.selectedItem}
            refresh={this.refresh}
          />
        )}
      </div>
    );
  }

  getEditItem() {
    const item = new ClientInvoiceLineItemModify();
    item.AssignmentIds = this.state.itemList
      .filter((i) => i.Selected && i.LineItemType.toLowerCase() === 'assignment')
      .map((f) => f.LineItemId);
    item.LineItemIds = this.state.itemList
      .filter((i) => i.Selected && i.LineItemType.toLowerCase() !== 'assignment')
      .map((f) => f.LineItemId);
    item.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    item.NumberOfItemsSelected = this.getNumberOfSelectedElements();
    item.ClientLineSearchItem = this.state.searchItem;
    item.ClCiId = this.props.clientInvoiceId;
    item.CurrencyId = this.state.currencyId;
    item.CcId = this.state.clientId;

    return item;
  }

  getApplyPaymentItem() {
    const item = new ApplyPaymentItem();
    item.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    item.NumberOfItemsSelected = this.getNumberOfSelectedElements();
    item.LineItemIds = this.state.itemList.filter((i) => i.Selected).map((f) => f.LineItem);
    item.ClientInvoiceId = this.props.clientInvoiceId;
    item.LineItemSearchParams = this.state.searchItem;
    return item;
  }

  removeFunction() {
    ClientLineItemService.RemoveLineItemsFromClientInvoice(this.getEditItem())
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          ErrorMessage.SetLoading(false);
          this.refresh(false);
          return;
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Line Item(s) Removed.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AST181', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ClientInvoiceLineItem}
          serviceFunction={VZeusLineItemOpenService.GetListBySearching}
          convertDBItemsFunction={VZeusLineItemOpenService.ConvertDBItems}
          searchParamsType={ClientInvoiceLineItemSearchParams}
          searchItem={this.state.searchItem}
          orderBy='Name'
          selectable={this.state.shownPanel === ShownPanelsEnum.None}
          itemList={this.state.itemList}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          changeOfItemListFunction={this.changeOfItemListFunction}
          errorCode='LIST220'
        />
      </div>
    );
  }
}
